import {Mapper} from '@s-ui/domain'

export default class TaxRawDataToTaxVOMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  map = ({tax: {type, percentage, amount}}) => {
    const fromIntegerToDecimal = value => value / 100
    return this._valueObject({
      type,
      percentage,
      amount,
      amountLabelValue: fromIntegerToDecimal(amount)
    })
  }
}
